import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const links = ['home', 'about', 'services', 'projects', 'team'];

  return (
    <>
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        {[...links, 'contact'].map(l => (
          <a key={l} href={`#${l}`} onClick={() => setMenuOpen(false)}>
            {l.charAt(0).toUpperCase() + l.slice(1)}
          </a>
        ))}
      </div>

      <nav className={scrolled ? 'scrolled' : ''}>
        <a href="#home" className="nav-logo">
          <div className="logo-mark">
            <svg viewBox="0 0 32 32" fill="white">
              <path d="M16 4C9.37 4 4 9.37 4 16s5.37 12 12 12 12-5.37 12-12S22.63 4 16 4zm0 3c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm-3 5v2.5h2.5v5H13V22h6v-2.5h-2.5V12H13z" />
            </svg>
          </div>
          <div className="logo-text">
            <div className="name">FM MAEPA (PTY) LTD</div>
            <div className="tagline">Engineering</div>
          </div>
        </a>

        <ul className="nav-links">
          {links.map(l => (
            <li key={l}><a href={`#${l}`}>{l.charAt(0).toUpperCase() + l.slice(1)}</a></li>
          ))}
          <li><a href="#contact" className="nav-cta">Contact Us</a></li>
        </ul>

        <button className="hamburger" onClick={() => setMenuOpen(o => !o)}>
          <span /><span /><span />
        </button>
      </nav>
    </>
  );
}
